// Pure position math for moving a sub-item (Task 4 menu fallback, Task 6 drag).
// Positions are sparse integers (~1000 apart); a new tail item lands at the
// current maximum + 1000, or at 1000 when the target has no members yet.
interface PosRow {
  id: string;
  parentRowId: string | null;
  position: number;
}

/** Position for a sub-item appended as the last child of `parentId`. */
export function nextChildPosition(rows: PosRow[], parentId: string): number {
  const max = rows
    .filter((r) => r.parentRowId === parentId)
    .reduce((m, r) => Math.max(m, r.position), 0);
  return max + 1000;
}

/** Position for a row appended after the last top-level entry. */
export function nextTopLevelPosition(rows: PosRow[], topLevelIds: string[]): number {
  const set = new Set(topLevelIds);
  const max = rows.filter((r) => set.has(r.id)).reduce((m, r) => Math.max(m, r.position), 0);
  return max + 1000;
}
